import React from 'react';
import UnifiedHeader from './UnifiedHeader';
import Footer from './Footer';
import CallbackButton from './CallbackButton';
import PhoneCopyToast from './PhoneCopyToast';
import '../css/Layout.css';

const Layout = ({ children, className = '' }) => {
    return (
        <div className={`layout ${className}`}>
            <UnifiedHeader />
            <main className="content">{children}</main>
            <Footer />
            <CallbackButton />
            <PhoneCopyToast />
        </div>
    );
};

export default Layout;
